<script lang="ts">
  import { formatDate } from './format';
  import SeverityBadge from './SeverityBadge.svelte';
  import type { GuardDutyFinding } from './types';

  let { findings, showCustomer = true }: { findings: GuardDutyFinding[]; showCustomer?: boolean } = $props();

  function findingStatus(finding: GuardDutyFinding): string {
    const states: string[] = [];
    if (finding.acknowledged) states.push('Acknowledged');
    if (finding.suppressed) states.push('Suppressed');
    return states.length ? states.join(' · ') : `${finding.eventCount} ${finding.eventCount === 1 ? 'update' : 'updates'}`;
  }
</script>

<div class="finding-list">
  {#each findings as finding}
    <a class:suppressed={finding.suppressed} class:acknowledged={finding.acknowledged} href={`/guardduty/findings/${finding.id}`}>
      <header>
        <SeverityBadge band={finding.severityBand} severity={finding.severity} />
        <time>{formatDate(finding.updatedAt)}</time>
      </header>
      <h3>{finding.title}</h3>
      <code>{finding.type}</code>
      <p>{finding.description}</p>
      <footer>
        <span>{showCustomer ? `${finding.customerName} · ` : ''}{finding.accountName} · {finding.region}</span>
        <span>{findingStatus(finding)}</span>
      </footer>
    </a>
  {/each}
</div>

<style>
  .finding-list { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 330px), 1fr)); border: 1px solid var(--line); border-radius: 1rem; overflow: hidden; background: var(--surface); box-shadow: var(--shadow); }
  a { display: flex; min-height: 15.5rem; flex-direction: column; padding: 1.35rem; color: var(--ink); text-decoration: none; border-right: 1px solid var(--line); border-bottom: 1px solid var(--line); }
  a:hover { color: var(--ink); background: #f9fbfd; }
  a.suppressed, a.acknowledged { background: #f5f6f8; opacity: .8; }
  header, footer { display: flex; justify-content: space-between; gap: .8rem; }
  time, footer { color: var(--muted); font-size: .76rem; }
  h3 { margin: 1rem 0 .4rem; }
  code { color: var(--brand-dark); font-size: .75rem; }
  p { margin: .8rem 0; color: var(--muted); line-height: 1.45; display: -webkit-box; overflow: hidden; -webkit-box-orient: vertical; -webkit-line-clamp: 3; line-clamp: 3; }
  footer { margin-top: auto; }
</style>
